export default {
  placeholder: '请选择',
  title: '请选择地区',
  domesticTab: '内地与港澳台',
  overseasTab: '海外',
  domesticInlandTab: '中国内地',
  zonesTab: '港澳台地区'
};